import WarningIcon from '@icons/warning-sign.svg?react'
import cn from '@integrations/classnames'
import { tr } from 'mmfintech-commons'
import styles from '../AccountWarning.module.scss'

function WarningHeader() {
  return (
    <div className={cn(styles['account-warning-heading'], 'account-warning-heading')}>
      <WarningIcon />
      {tr('FRONTEND.BANKING.COMMON.WARNING_TITLE', 'Please note')}
    </div>
  )
}

export default WarningHeader
